// AI探索境界: docs/design/foundation/responsibility/shopify-theme-boundary-map.md
(function () {
  const productsFilters = () => {
    const products = document.querySelectorAll('.collection-popular-card');
    const limit = products.length;

    document.querySelectorAll('.filters__item').forEach(item => {      
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const typeTarget = item.dataset.typeTarget;
        document.querySelectorAll('.filters__item').forEach(element => {
          element.classList.remove('filters__item_active');
        })
        item.classList.add('filters__item_active');

        let i = 0;
        products.forEach(element => {
          let productType = element.dataset.type;
          if ((productType == typeTarget || typeTarget == "all") && i < limit) {
            element.classList.add('show');
            i++;
          }
          else {
            element.classList.remove('show');
          }
        });
      })
    })
  }

  const viewMoreButtons = () => {
    document.querySelectorAll('[data-popular-products-view-more]').forEach((button) => {
      button.addEventListener('click', () => {
        const wrapper = button.closest('.popular-products');
        wrapper.querySelectorAll('.collection-popular-card').forEach((card) => {
          card.classList.add('show');
        });
        button.closest('.popular-products__view-more-wrapper').remove();
      });
    });
  }

  productsFilters();
  viewMoreButtons();

  document.addEventListener('shopify:section:load', function () {
		productsFilters();
		viewMoreButtons();
	});
})();